import { AxiosResponse } from "axios";

import { appConstants } from "../config/app-constants";
import {
  ICreateEFilingMsg,
  IEfilingMessage,
  IFilingDocument,
  IMsgParams
} from "../config/interfaces";
import InitApi from "./init";

class MSGFilingApi {
  static _instance: MSGFilingApi;

  static getInstance = () => {
    if (this._instance) {
      return this._instance;
    }
    this._instance = new MSGFilingApi();
    return this._instance;
  };

  _apiSvc;

  constructor() {
    this._apiSvc = InitApi.getInstance();
  }

  createFilingMsg = async (data: ICreateEFilingMsg): Promise<AxiosResponse> => {
    return this._apiSvc.post(`${appConstants.apiUrl}/efiling-message`, data);
  };

  updateFilingMsg = async (data: IFilingDocument, uuid: string): Promise<AxiosResponse> => {
    const response = await this._apiSvc.post(
      `${appConstants.apiUrl}/efiling-message/single/${uuid}`,
      data
    );
    return response.data;
  };

  getFilingMsgById = async (uuid: string): Promise<AxiosResponse> => {
    return this._apiSvc.get(`${appConstants.apiUrl}/efiling-message/single${uuid}`);
  };

  getFilingMsgs = async (params: IMsgParams): Promise<{ records: IEfilingMessage[] }> => {
    const { offset = 0, count = -1, efilingUuid, orderBy } = params;
    let url = `efiling-message?offset=${offset}`;

    if (count) {
      url += `&count=${count}`;
    }

    if (orderBy) {
      url += `&order=${orderBy}`;
    }

    if (efilingUuid) {
      url += `&efilingUuid=${efilingUuid}`;
    }

    const response = await this._apiSvc.get(`${appConstants.apiUrl}/${url}`);
    return response.data;
  };

  deleteFilingMsg = async (data: any): Promise<AxiosResponse> => {
    return this._apiSvc.delete(`${appConstants.apiUrl}/efiling-message`, { data });
  };
}

export default MSGFilingApi;
